module.exports = __webpack_public_path__ + "img/weddingrings@2x.c823322.jpg";